import { useState } from "react";


export const useTwoStepAuthCodeStates = () => {
  // 2段階認証コンポーネント表示フラグ
  const [isShowTwoStepAuth, setIsShowTwoStepAuth] = useState(false);
  // 2段階認証コード入力モーダル表示フラグ（falseの場合は2段階認証解除コード入力モーダルが表示される）
  const [isCodeModal, setIsCodeModal] = useState(true);

  const [code, setCode] = useState("");
  const [releaseCode, setReleaseCode] = useState("");

  // 2段階認証コード実行ボタン有効フラグ
  const [isActiveCodeVerifyButton, setIsActiveCodeVerifyButton] = useState(false);
  // 2段階認証解除コード実行ボタン有効フラグ
  const [isActiveReleaseCodeVerifyButton, setIsActiveReleaseCodeVerifyButton] = useState(false);
  // 2段階認証コード実行ボタン有効フラグ
  const [isActiveSetCodeVerifyButton, setIsActiveSetCodeVerifyButton] = useState(false);

  return {
    isShowTwoStepAuth,
    setIsShowTwoStepAuth,
    isCodeModal,
    setIsCodeModal,
    code,
    setCode,
    releaseCode,
    setReleaseCode,
    isActiveCodeVerifyButton,
    setIsActiveCodeVerifyButton,
    isActiveReleaseCodeVerifyButton,
    setIsActiveReleaseCodeVerifyButton,
    isActiveSetCodeVerifyButton,
    setIsActiveSetCodeVerifyButton,
  };
};
